import React, { useState } from "react";
import { Box, Popover, Typography } from "@mui/material";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
  ThreadsShareButton,
  ThreadsIcon,
} from "react-share";
import InstagramWebShare from "./Instashare";
import shareIcon from "../../../../assets/customerAssets/icons/share.svg";
import styles from "./styles.module.css";

const Index = ({ data, title, shareUrl }) => {
  const [sharePop, setSharePop] = useState(null);
  const shareOpen = Boolean(sharePop);

  return (
    <Box className={styles.share_wrapper}>
      <div
        className={styles.icon_div}
        id="share-popup"
        onClick={(e) => {
          setSharePop(e.currentTarget);
        }}
      >
        <img src={shareIcon} className={styles.icon_img} />
      </div>
      <Popover
        id={"share-popup"}
        open={shareOpen}
        anchorEl={sharePop}
        onClose={() => setSharePop(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPopover-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "visible",
          },
        }}
      >
        <Box
          className={
            shareOpen ? `${styles.share_box} ${styles.show}` : styles.share_box
          }
        >
          <FacebookShareButton
            url={shareUrl}
            title={`check this out ! ${data.title}`}
          >
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton
            url={shareUrl}
            title={`check this out ! ${data.title}`}
          >
            <XIcon size={32} round />
          </TwitterShareButton>
          <WhatsappShareButton
            url={shareUrl}
            title={`check this out ! ${data.title}`}
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          <ThreadsShareButton
            url={shareUrl}
            title={`check this out ! ${data.title}`}
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
          <InstagramWebShare url={shareUrl} />
        </Box>
      </Popover>
    </Box>
  );
};

export default Index;
